import {
	DocumentTemplate,
	DocumentTemplateType,
} from '../data/interfaces/DocumentTemplate';

export const isDynamicTemplate = (templateType: string) => templateType === 'Dynamic';

export const getTemplateType = (documentTemplate: DocumentTemplate) => {
	let templateType: DocumentTemplateType;

	if (!documentTemplate) {
		templateType = null;
	} else if (
		!documentTemplate?.templateType ||
		documentTemplate?.templateType === 'Static'
	) {
		templateType = 'Static';
	} else {
		templateType = 'Dynamic';
	}
	return templateType;
};
